export function detectTrafficSource() {
  // UTM parameters take priority (most reliable - from shared links)
  const params = new URLSearchParams(window.location.search);
  const utmSource = (params.get("utm_source") || "").toLowerCase().trim();

  if (utmSource) {
    if (utmSource.includes("instagram")) return "instagram";
    if (utmSource.includes("facebook") || utmSource.includes("fb")) return "facebook";
    if (utmSource.includes("whatsapp") || utmSource.includes("wa")) return "whatsapp";
    if (utmSource.includes("google")) return "google";
    if (utmSource.includes("twitter") || utmSource === "x") return "twitter";
    if (utmSource.includes("tiktok")) return "tiktok";
    if (utmSource.includes("snapchat")) return "snapchat";
    if (utmSource.includes("youtube")) return "youtube";
    if (utmSource.includes("linkedin")) return "linkedin";
    return utmSource;
  }

  // Fall back to referrer
  const ref = (document.referrer || "").toLowerCase();

  if (!ref) return "direct";
  if (ref.includes("instagram.com") || ref.includes("l.instagram.com")) return "instagram";
  if (ref.includes("facebook.com") || ref.includes("l.facebook.com") || ref.includes("fb.com")) return "facebook";
  if (ref.includes("google.")) return "google";
  if (ref.includes("twitter.com") || ref.includes("t.co") || ref.includes("x.com")) return "twitter";
  if (ref.includes("tiktok.com")) return "tiktok";
  if (ref.includes("snapchat.com")) return "snapchat";
  if (ref.includes("youtube.com")) return "youtube";
  if (ref.includes("linkedin.com")) return "linkedin";
  if (ref.includes("whatsapp.com") || ref.includes("wa.me")) return "whatsapp";

  return "other";
}
